.content {
  word-break: break-word;
  box-sizing: border-box;
  cursor: pointer;
  background-color: var(--dds-color-surface-default);
  border: 1px solid;
  height: 100%;

  @media (prefers-reduced-motion: no-preference) {
    transition:
      border-color var(--dds-motion-micro-state),
      background-color var(--dds-motion-micro-state),
      box-shadow var(--dds-motion-micro-state),
      color var(--dds-motion-micro-state),
      var(--dds-focus-transition);
  }
}

.label {
  &:first-child .content {
    margin-inline-end: -1px;
    border-top-left-radius: var(--dds-border-radius-button);
    border-bottom-left-radius: var(--dds-border-radius-button);
  }
  &:last-child .content {
    border-top-right-radius: var(--dds-border-radius-button);
    border-bottom-right-radius: var(--dds-border-radius-button);
  }

  &:not(:first-child):not(:last-child) .content {
    margin-inline-end: -1px;
  }

  input:focus-visible + .content,
  input:checked + .content {
    position: relative;
    z-index: 0;
    border-radius: var(--dds-border-radius-button);
  }
}

.label--primary {
  .content {
    border-color: var(--dds-color-border-default);
  }
  &:hover .content {
    background-color: var(--dds-color-surface-hover-default);
  }

  input:checked + .content {
    color: var(--dds-color-text-on-action);
    border-color: var(--dds-color-surface-action-selected);
    background-color: var(--dds-color-surface-action-selected);
  }
}

.label--secondary {
  .content {
    border-color: var(--dds-color-border-subtle);
  }
  &:hover .content {
    background-color: var(--dds-color-surface-hover-subtle);
  }

  input:checked + .content {
    color: var(--dds-color-text-default);
    border-color: var(--dds-color-border-default);
    background-color: var(--dds-color-surface-selected-default);
  }
}
